import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Webgametechstack() {
  return (
    <section
      className="web_game_techstack crm-tech-stack p-100"
      style={{ background: "#f9f9f9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Our Toolbox for <span>CRM Software Development</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Use the information provided through our in-house developed CRM
              software to make wiser decisions. Convenient tools for generating
              reports and analyzing customers’ activity, sales rates, and
              productive performance enable decision-makers to focus on
              strategic actions supported by the actual data gained.
            </p>
          </Col>
          <Row className="mt-3 mt-md-5">
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={10}
              xxl={10}
              className="m-auto text-center"
            >
              <div className="web_game_tech_main">
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../../images/solution/crm-new/tech-stack/AngularJs.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={86}
                      height={86}
                    />
                  </div>
                  <h5>AngularJs</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../../images/solution/crm-new/tech-stack/AWS.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={86}
                      height={86}
                    />
                  </div>
                  <h5>AWS</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../../images/solution/crm-new/tech-stack/CSS.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={86}
                      height={86}
                    />
                  </div>
                  <h5>CSS</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../../images/solution/crm-new/tech-stack/HTML.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={86}
                      height={86}
                    />
                  </div>
                  <h5>HTML</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../../images/solution/crm-new/tech-stack/Java.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={86}
                      height={86}
                    />
                  </div>
                  <h5>Java</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../../images/solution/crm-new/tech-stack/JS.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={86}
                      height={86}
                    />
                  </div>
                  <h5>JavaScript</h5>
                </div>
              </div>
            </Col>
          </Row>
        </Row>
      </Container>
    </section>
  );
}

export default Webgametechstack;
